/**
 * @fileoverview GET handler for the "/alloys/:provider/agentic/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysProviderAgenticAppGroupId } from "./constants";
import type { GetAlloysProviderAgenticAppGroupIdResult } from "./types";
import { isGetAlloysProviderAgenticAppGroupIdResult } from "./validators";

export const getAlloysProviderAgenticAppGroupId = reactQueryFetcherAdapter(
  alloysProviderAgenticAppGroupId,
  (
    signal: AbortSignal,
    provider: string,
    appGroupId: string
  ): Promise<GetAlloysProviderAgenticAppGroupIdResult> => {
    return fetch(
      `/alloys/${provider}/agentic/${appGroupId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetAlloysProviderAgenticAppGroupIdResult
);
